import React from "react";
import { withStyles, withTheme } from "@material-ui/core";
import styles from "../../../styles";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import Map, {
  MapControls,
  MapConstant,
  Marker,
} from "../../../../../../lib/Map";
import Events from "../../../../../../utilities/EventEmitter";
import { withAppConfig } from "../../../../../../appConfigContext";
import {
  TerminalMarker,
  DropYardMarker,
} from "../../../../../../components/mapComponents/Markers";
import MapHeader from "./components/MapHeader";
import DropYardsDrawer from "./components/DropYardsDrawer";
import DrawingTools from "../../../common/DrawTools/DrawingTools";
import appConstants from "../../../../../../appConstants";
import DrawStyles from "../../../../../../lib/Map/Trimble/components/DrawStyles";
import { getExistingFeaturesGeoJSON } from "./utils";
import isEqual from "lodash/isEqual";
import drawConstant from "../../../common/DrawTools/DrawConstant";

class DropYardMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAutoZoomEnabled: true,
      isDropYardRegionEnabled: false,
      geoDataList: [],
    };
    this.drawStyles = DrawStyles();
  }

  componentDidUpdate(prevProps, prevState) {
    const dropYardEnabledChanged =
      this.state.isDropYardRegionEnabled !== prevState.isDropYardRegionEnabled;
    const dropYardsChanged = !isEqual(this.props.data, prevProps.data);

    if (dropYardEnabledChanged || dropYardsChanged) {
      if (this.state.isDropYardRegionEnabled) {
        const geoJson = getExistingFeaturesGeoJSON(this.props.data);
        this.setState({ geoDataList: geoJson });
      } else {
        this.setState({ geoDataList: [] });
      }
    }
  }

  toggleRouteAnimation = (value) => {
    this.setState({
      isAutoZoomEnabled: value,
    });
  };

  onMapClick = (e) => {
    this.props.dropYardClickedOnMap(null);
  };

  getDropYardMarkerInfo = (dropYard) => {
    return {
      name: dropYard.dropYardName,
      address: dropYard.address,
    };
  };

  handleDropYardRegionToggle = (e) => {
    this.setState({
      isDropYardRegionEnabled: e.target.checked,
    });
    if (e.target.checked !== this.props.isMapMaximized) {
      this.props.toggleMaximize();
    }
    this.props.eventHub.emit("mapResize");
  };

  onScaleDrawingComplete = (feature, type) => {
    if (
      [
        MapConstant.DRAWING_EVENTS.CREATE,
        MapConstant.DRAWING_EVENTS.UPDATE,
      ].includes(type)
    ) {
      Events.emit(drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_UPDATED, feature);
    }
  };

  render() {
    const {
      classes,
      theme,
      data,
      configJSON,
      selectedDropYardId,
      dropYardClickedOnMap,
      terminalList,
      selectedTerminalInFilter,
    } = this.props;
    const { location: terminalLocation, code: terminalID } =
      this.props.userData.userProfile.terminal;
    return (
      <div className={classes.anchorSubModulePart}>
        <MapHeader
          isAutoZoomEnabled={this.state.isAutoZoomEnabled}
          toggleRouteAnimation={this.toggleRouteAnimation}
          userData={this.props.userData}
          Events={Events}
          isDropYardRegionEnabled={this.state.isDropYardRegionEnabled}
          handleDropYardRegionToggle={this.handleDropYardRegionToggle}
          isMapMaximized={this.props.isMapMaximized}
          toggleMaximize={this.props.toggleMaximize}
        />
        <div className={classes.anchorPointModuleContainer}>
          <div
            className={`${classes.anchorPointContent} ${classes.flexContainer}`}
          >
            <Map
              zoom={selectedTerminalInFilter ? 9 : 3}
              initialCenter={terminalLocation}
              center={terminalLocation}
              mapId={appConstants.mapIds.DROP_YARD_MAP}
              mapTheme={theme.themeName}
              mapConfig={configJSON?.maps}
              onClick={this.onMapClick}
              eventHub={this.props.eventHub}
            >
              <MapControls
                controlOptions={{
                  zoomControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  satelliteViewControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  reCenterMapControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  showZones: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                    dropYardID: terminalID,
                    geoJson: this.props.userData.userProfile?.geoJson,
                  },
                }}
              />
              {selectedTerminalInFilter &&
                terminalList?.map((terminal) => {
                  const isActive =
                    selectedTerminalInFilter == terminal.terminalId;
                  return (
                    isActive && (
                      <Marker
                        data={terminal}
                        position={{
                          lat: terminal.latitude,
                          lng: terminal.longitude,
                        }}
                        key={terminal.terminalCode}
                        forceUpdate={true}
                        isActiveShipment={
                          this.state.isAutoZoomEnabled && isActive
                        }
                        zIndex={1}
                      >
                        <TerminalMarker
                          data={{
                            name: terminal.terminalName,
                            address: terminal.address,
                          }}
                        />
                      </Marker>
                    )
                  );
                })}
              {data?.map((dropYard) => {
                const isActive = selectedDropYardId.includes(dropYard.dropYardId);
                const size = isActive ? "40" : "25";
                return (
                  <Marker
                    data={{ ...dropYard, size }}
                    position={{
                      lat: dropYard.latitude,
                      lng: dropYard.longitude,
                    }}
                    key={dropYard.dropYardId}
                    onClick={dropYardClickedOnMap}
                    forceUpdate={true}
                    isActiveShipment={this.state.isAutoZoomEnabled && isActive}
                    zIndex={1}
                  >
                    <DropYardMarker
                      data={this.getDropYardMarkerInfo(dropYard)}
                      size={size}
                    />
                  </Marker>
                );
              })}
              <DrawingTools
                polygonOptions={{
                  fillColor: theme.MapDrawingColor,
                  strokeColor: theme.MapDrawingColor,
                }}
                geoDataList={this.state.geoDataList}
                styleArray={this.drawStyles}
                eventHub={Events}
                onDrawingComplete={this.onScaleDrawingComplete}
                mode={this.state.isDropYardRegionEnabled ? "create" : "edit"}
              />
            </Map>
            {this.state.isDropYardRegionEnabled && (
              <DropYardsDrawer
                dropYardList={data}
                geoDataList={this.state.geoDataList}
                dropYardClickedOnMap={dropYardClickedOnMap}
                CommonStore={this.props.CommonStore}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme(),
  withUserProfile,
  withAppConfig
)(DropYardMap);
